module.exports = __webpack_public_path__ + "static/media/doc_red.e35f4b86.png";